import * as React from 'react'
import { Link } from 'widgets-for-react'

export type Breadcrumb = { url: string; title: string }

export const Breadcrumbs = ({ breadcrumbs }: { breadcrumbs: Array<Breadcrumb> }): JSX.Element => (
  <nav className="breadcrumb text--s">
    <div className="breadcrumb__inner container container--m grid--gutter">
      <ul className="breadcrumb__list">
        {breadcrumbs.map(
          (b, index): JSX.Element => (
            <li key={index} className="breadcrumb__item">
              <Link
                to={b.url}
                className="breadcrumb__link"
                title={b.title}
                {...(index == breadcrumbs.length - 1 && { 'aria-current': 'location' })}
              >
                {b.title}
              </Link>
            </li>
          )
        )}
      </ul>
    </div>
  </nav>
)
